import { IDeductionTypeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";
export class GetDeductionTypeUseCase {
    constructor(private readonly lookupRepository: LookupRepository) { }

    async execute(): Promise<IDeductionTypeRepositoryResponse> {
        return this.lookupRepository.getDeductionTypes();
    }
}